import API from "../../../apiWrapper";
import IPaymentPlanSettings from '../../../../interfaces/dashboard/IPaymentPlanWidgetSettings';
import { Download } from "../../../../utils/file";
import { ToBlob } from "../../../../utils/base64Helper";

export const GetPaymentPlanWidgetData = (campusId: string, asOfDate: string | null, showAll: boolean) => {
	return API()
		.get("/FinancialAid/PaymentPlanWidget/GetPaymenPlanDataForWidget", {
			params: {
				campusId,
				asOfDate,
				showAll,
			},
		})
		.then(
			(res: any) => {
				if (res && res.data) {
					return res;
				}
			},
			(error: any) => {
				return error;
			}
		);
};

export const upsertPaymentPlanSettings = (
	terminationSettings: IPaymentPlanSettings
) => {
	return API()
		.post("/FinancialAid/PaymentPlanWidget/UpsertPaymentPlanSettings", terminationSettings)
		.then(
			(res: any) => {
				if (res && res.data) {
					return res;
				}
			},
			(error: any) => {
				return error;
			}
		);
};

export const updateContactedFlagForPaymentPlan = (
	checkList: []
) => {
	return API()
		.post("/FinancialAid/PaymentPlanWidget/UpdateContactedFlagForPaymentPlan", checkList)
		.then(
			(res: any) => {
				if (res && res.data) {
					return res;
				}
			},
			(error: any) => {
				return error;
			}
		);
};


export const getPaymentPlanSettings = (
	campusId: string
) => {
	return API()
		.get("/FinancialAid/PaymentPlanWidget/GetPaymentPlanSettings", {
			params: {
				campusId
			}
		})
		.then(
			(res: any) => {
				if (res && res.data) {
					return res;
				}
			},
			(error: any) => {
				return error;
			}
		);
};

// GetStudentPaymentPlans

export const getStudentPaymentPlansByEnrollmentId = (enrollmentId: string) => {
	return API()
		.get("/FinancialAid/PaymentPlan/GetPaymentPlans", {
			params: {
				enrollmentId
			}
		})
		.then(
			(res: any) => {
				if (res && res.data) {
					return res;
				}
			},
			(error: any) => {
				return error;
			}
		);
};

export const getStudentPaymentPlanByPPID = (paymentPlanId: string) => {
	return API()
		.get("/FinancialAid/PaymentPlan/GetStudentPaymentPlans", {
			params: {
				paymentPlanId
			}
		})
		.then(
			(res: any) => {
				if (res && res.data) {
					return res;
				}
			},
			(error: any) => {
				return error;
			}
		);
};

export const AddPaymentPlan = (paymentPlanData: any) => {
	var res = API()
		.post("/FinancialAid/PaymentPlan/SaveStudentPaymentPlans", paymentPlanData)
		.then(
			(res: any) => {
				if (res && res.data) {
					return res.data;
				}
			},
			(error: any) => {
				return error.response;
			}
		);

	return res;
};

export const UpdatePaymentPlan = (paymentPlanData: any) => {
	var res = API()
		.post("/FinancialAid/PaymentPlan/UpdateStudentPaymentPlans", paymentPlanData)
		.then(
			(res: any) => {
				if (res && res.data) {
					return res.data;
				}
			},
			(error: any) => {
				return error.response;
			}
		);

	return res;
};


export const getPaymentPlanReport = (paymentPlanId: string, campusId: string) => {
	return API()
		.post("/StudentAccounts/PaymentPlan/GetPaymentPlanReport", {
			paymentPlanId: paymentPlanId,
			campusId: campusId

		}, { responseType: "blob" })
		.then(
			(res: any) => {
				if (res && res.data) {
					return res;
				}
			},
			(error: any) => {
				return error;
			}
		);
};

export const closeOutPaymentPlan = (paymentPlanId: string) => {
	return API()
		.post("/FinancialAid/PaymentPlan/CloseOutStudentPaymentPlan", paymentPlanId, {
			headers: { "Content-Type": "application/json" }
		})
		.then(
			(res: any) => {
				if (res && res.data) {
					return res;
				}
			},
			(error: any) => {
				return error;
			}
		);
};

export const deleteStudentPaymentPlan = (paymentPlanId: string) => {
	return API().delete(`/FinancialAid/PaymentPlan/DeleteStudentPaymentPlan`, {
		params: { paymentPlanId }
	});
};